/* eslint-disable import-helpers/order-imports */
import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'react-credit-cards/lib/styles.scss';
import 'react-toastify/dist/ReactToastify.css';
import 'cleave.js/dist/addons/cleave-phone.in';
import 'react-credit-cards/es/styles-compiled.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import ptBR from 'rsuite/locales/pt_BR';

import 'presentation/app/assets/scss/themes.scss';
import '@repo/ui/styles.css';
import 'rsuite/DateRangePicker/styles/index.css';

import { createSelector } from 'reselect';
// eslint-disable-next-line import-helpers/order-imports
import { CustomProvider } from 'rsuite';

import { Router } from './main/routing';

import { useSelector } from 'react-redux';
function App() {
  const layout = createSelector(
    (state) => state.Layout,
    (layoutModeType) => layoutModeType.layoutModeType,
  );
  const layoutModeType = useSelector(layout);
  return (
    <CustomProvider theme={layoutModeType} locale={ptBR}>
      <ToastContainer />
      <Router />
    </CustomProvider>
  );
}

export default App;


